export default __webpack_public_path__ + "static/summer_containers66-44aca2f362746323eccaef0d39478909.webp";